import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Shirt, Calendar, Award, Check } from 'lucide-react';
import { Button } from '../ui/Button';
export function TrialSpotlight() {
  return <section className="py-20 bg-primary relative overflow-hidden" data-id="element-105">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10" data-id="element-106">
        <div className="absolute inset-0" style={{
        backgroundImage: 'radial-gradient(#ffffff 1px, transparent 1px)',
        backgroundSize: '30px 30px'
      }} data-id="element-107"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-108">
        <div className="bg-white rounded-2xl shadow-2xl overflow-hidden" data-id="element-109">
          <div className="grid grid-cols-1 lg:grid-cols-2" data-id="element-110">
            <div className="p-8 md:p-12 lg:p-16 flex flex-col justify-center" data-id="element-111">
              <motion.div initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} data-id="element-112">
                <div className="inline-block px-4 py-1 bg-accent/10 text-accent font-bold rounded-full text-sm mb-6" data-id="element-113">
                  LIMITED TIME OFFER
                </div>
                <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6" data-id="element-114">
                  4 WEEKS FOR $39 <br data-id="element-115" />
                  <span className="text-primary" data-id="element-116">INCLUDING UNIFORM</span>
                </h2>

                <ul className="space-y-4 mb-8" data-id="element-117">
                  <li className="flex items-center text-gray-700" data-id="element-118">
                    <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-119" />
                    <span data-id="element-120">4 consecutive weeks of classes</span>
                  </li>
                  <li className="flex items-center text-gray-700" data-id="element-121">
                    <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-122" />
                    <span data-id="element-123">Official uniform included ($50 value)</span>
                  </li>
                  <li className="flex items-center text-gray-700" data-id="element-124">
                    <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-125" />
                    <span data-id="element-126">1 promotion per person</span>
                  </li>
                  <li className="flex items-center text-gray-700" data-id="element-127">
                    <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-128" />
                    <span data-id="element-129">No other obligations</span>
                  </li>
                </ul>

                <Link to="/trial" data-id="element-130">
                  <Button size="lg" className="w-full sm:w-auto text-lg px-8 py-6" data-id="element-131">
                    Claim Your Trial
                  </Button>
                </Link>
                <p className="mt-4 text-sm text-gray-500" data-id="element-132">
                  Perfect for beginners. No experience necessary.
                </p>
              </motion.div>
            </div>

            <div className="relative bg-gray-50 p-8 md:p-12 lg:p-16 flex items-center justify-center border-t lg:border-t-0 lg:border-l border-gray-100 overflow-hidden" data-id="element-133">
              {/* Background image with lighter overlay */}
              <div className="absolute inset-0 z-0" data-id="element-134">
                <div className="absolute inset-0 bg-white/70 z-10" data-id="element-135" />
                <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
                backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/v36ZSq4nbEMxUyVxWt9UWo/image.png)'
              }} data-id="element-136" />
              </div>

              <div className="grid grid-cols-1 gap-8 w-full max-w-md relative z-20" data-id="element-137">
                <motion.div className="flex items-center bg-white p-6 rounded-xl shadow-sm" initial={{
                opacity: 0,
                y: 20
              }} whileInView={{
                opacity: 1,
                y: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: 0.1
              }} data-id="element-138">
                  <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-4 flex-shrink-0" data-id="element-139">
                    <Shirt className="w-6 h-6 text-primary" data-id="element-140" />
                  </div>
                  <div data-id="element-141">
                    <h3 className="font-bold text-gray-900" data-id="element-142">Free Uniform</h3>
                    <p className="text-sm text-gray-600" data-id="element-143">
                      High-quality training uniform included
                    </p>
                  </div>
                </motion.div>

                <motion.div className="flex items-center bg-white p-6 rounded-xl shadow-sm" initial={{
                opacity: 0,
                y: 20
              }} whileInView={{
                opacity: 1,
                y: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: 0.2
              }} data-id="element-144">
                  <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center mr-4 flex-shrink-0" data-id="element-145">
                    <Calendar className="w-6 h-6 text-accent" data-id="element-146" />
                  </div>
                  <div data-id="element-147">
                    <h3 className="font-bold text-gray-900" data-id="element-148">4 Weeks Access</h3>
                    <p className="text-sm text-gray-600" data-id="element-149">
                      Unlimited classes for your age group
                    </p>
                  </div>
                </motion.div>

                <motion.div className="flex items-center bg-white p-6 rounded-xl shadow-sm" initial={{
                opacity: 0,
                y: 20
              }} whileInView={{
                opacity: 1,
                y: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: 0.3
              }} data-id="element-150">
                  <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mr-4 flex-shrink-0" data-id="element-151">
                    <Award className="w-6 h-6 text-purple-600" data-id="element-152" />
                  </div>
                  <div data-id="element-153">
                    <h3 className="font-bold text-gray-900" data-id="element-154">Earn Your Belt</h3>
                    <p className="text-sm text-gray-600" data-id="element-155">
                      Opportunity to test for your first rank
                    </p>
                  </div>
                </motion.div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}